const SOCIAL_NETWORKS_BY_HOST = new Map([
    ['facebook.com', 'facebook'],
    ['instagram.com', 'instagram'],
    ['linkedin.com', 'linkedin'],
    ['twitter.com', 'x'],
    ['x.com', 'x'],
    ['youtu.be', 'youtube'],
    ['youtube.com', 'youtube'],
]);

export const getSocialNetwork = (href, baseUrl = 'https://corim-solutions.com/') => {
    try {
        const hostname = new URL(href, baseUrl).hostname.toLowerCase();
        const socialHost = [...SOCIAL_NETWORKS_BY_HOST.keys()].find(
            (host) => hostname === host || hostname.endsWith(`.${host}`),
        );

        return socialHost ? SOCIAL_NETWORKS_BY_HOST.get(socialHost) : null;
    } catch {
        return null;
    }
};
